import React from 'react'
import { Helmet } from 'react-helmet'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

export const MetaInfo: React.FC = () => {
  const { appConfig } = getAppConfigMap()

  return (
    <Helmet>
      <title>{appConfig.displayName}</title>
      <meta name="description" content={appConfig.metaDescription} />
      <link rel="icon" href={appConfig.logoUrl} />
    </Helmet>
  )
}
